import { useEffect } from "react";
//import { useLocation } from "react-router-dom";
//import "./TermsAndConditions.css";
import TermsAndConditionsContent from './TermsAndConditionsContent.js';
//import cn from "classnames";
import styles from './terms.module.sass';

const TermsAndConditions = () => {

    return (

        <main>

            <section
                className = 'terms'
                style = {{
                    backgroundColor: "var(--color-gray-100)"
                }}
                >

                <div
                    className = 'max-width'
                    style = {{
                        backgroundColor: "white"
                    }}
                    >
                    
                    <TermsAndConditionsContent />
            
                </div>
            </section>
        </main>
    );
};

export default TermsAndConditions;
